import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { getGlobalDateDisplayFormat } from '@shared/utils/helpers/user-preferences';

@Pipe({
  name: 'dateWithFormat',
  standalone: false,
})
export class DateWithFormatPipe implements PipeTransform {
  constructor(public datePipe: DatePipe) {}

  /**
   * @param value: string which is used as input to date pipe
   * @param args: accepts object with keys suffixFormat and otherThanCode
   * suffixFormat tells if the date has to be displayed with any hours mins ext.
   * otherThanCode will specify if we have to use value from key/value (default is code)
   */
  transform(
    value: string,
    args: { suffixFormat?: string; otherThanCode?: string } = { suffixFormat: '', otherThanCode: 'code' }
  ): string {
    const { suffixFormat, otherThanCode } = args;
    const withSuffixFormat = getGlobalDateDisplayFormat(otherThanCode) + suffixFormat;
    return this.datePipe.transform(value, withSuffixFormat);
  }
}
